export enum UserTypeEnum {
  Professional = 'Professional',
  subscribedByProfessional = 'subscribedByProfessional',
  Standard = 'Standard',
}

export enum WorkSpaceMemberTypeEnum {
  professional = 'professional',
  family = 'family',
}

export enum ProfessionalUserRelationShip {
  id = 68,
  name = 'Client',
}

export enum ClientUserRelationship {
  id = 21,
  name = 'Professional',
}

export enum ClientSLimitMessage {
  message = 'you have reached maximum limit',
}
export enum MemberType {
  group = 'group',
}

export enum ClientSLimit {
  limit = 50,
}
export enum officeSearchType {
  Office = 'Office',
  Collaboration = 'Collaboration ',
}

export enum ReportType {
  balance = 'balance',
  assetMap = 'assetMap',
  cash = 'cash',
  ownership = 'ownership',
}

export enum linearGradientList {
  code1 = 'linear-gradient(83.82deg, #3FB1CA -1.01%, #15838A 98.87%)',
  code2 = 'linear-gradient(83.82deg, #611A99 -1.01%, #9421B1 98.87%)',
  code3 = 'linear-gradient(83.82deg, #2B991A -1.01%, #628C08 98.87%)',
  code4 = 'linear-gradient(83.82deg, #AF7B17 -1.01%, #DF8418 98.87%)',
  white = '#ffffff',
}

export enum lightLinearGradientList {
  code1 = 'linear-gradient(0deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7))  #1D74C5 !important;',
  code2 = 'linear-gradient(0deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7))  #125288 !important;',
  code3 = 'linear-gradient(0deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7))   #125288 !important;',
}

export enum lightcolorList {
  code1 = '#1D74C5',
  code2 = '#EDE1BB',
  code3 = '#17AF8B',
  code4 = '#D7B8C1',
}

export enum FamilyTreeMemberTypeEnum {
  family = 'family',
  professional = 'professional',
}
